import { DateInput3 } from '@blueprintjs/datetime2';
import PropTypes from 'prop-types';
import {
  DATE_FORMAT,
  defaultMaxDate,
  defaultMinDate,
  getDateAsUTC,
} from 'Util/dateUtil';
import styles from './BOSDates.module.css';

const BOSDateInput = ({
  value,
  onChange,
  maxDate = defaultMaxDate,
  minDate = defaultMinDate,
  isRequired = false,
  onBlur = () => {},
}) => {
  return (
    <DateInput3
      showActionsBar
      value={value}
      onChange={(newDate, isUserChange) =>
        isUserChange && onChange(getDateAsUTC(newDate))
      }
      dateFnsFormat={DATE_FORMAT}
      popoverProps={{ minimal: true, placement: 'bottom-start' }}
      placeholder={'mm/dd/yyyy'}
      minDate={minDate}
      maxDate={maxDate}
      closeOnSelection
      fill
      className={[
        styles.date_input,
        ...(isRequired && !value
          ? [`bp5-intent-danger ${styles.required}`]
          : []),
      ]}
      inputProps={{ onClick: onBlur }}
    />
  );
};

BOSDateInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  maxDate: PropTypes.objectOf(Date),
  minDate: PropTypes.objectOf(Date),
  isRequired: PropTypes.bool,
  onBlur: PropTypes.func,
};

export default BOSDateInput;
